import { AxiosResponse } from 'axios';
import {
  SET_ORGANIZATIONS,
  SET_ORGANIZATION,
  SET_ERRORMSG,
  SET_ACCOUNT,
  SET_ACCOUNT_ORGANIZATION,
} from '@/store/mutation_types';
import {
  CLEAR_ORGANIZATION_ISLOADING,
  DELETE_ORGANIZATION,
  EDIT_ORGANIZATION,
  GET_ORGANIZATIONS,
  GET_ORGANIZATION,
  REGISTER_ORGANIZATION,
  SIGNUP_ORGANIZATION,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Organization from '@/services/organization';
import { Module } from 'vuex';
import {
  EditOrganization,
  RegisterOrganization,
  GetOrganization,
} from '@/dtos/organization.dto';

const organization: Module<any, {}> = {
  state: {
    organization: {
      data: null,
      isLoading: false,
    },
    organizations: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    organization: (state: { organization: any }) => state.organization,
    organizations: (state: { organizations: any }) => state.organizations,
  },
  mutations: {
    [SET_ORGANIZATION]: (
      state: { organization: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.organization.data = payload.data) : null,
        (state.organization.isLoading = payload.isLoading);
    },
    [SET_ORGANIZATIONS]: (
      state: { organizations: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.organizations.data = payload.data) : null,
        (state.organizations.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_ORGANIZATION]: async ({ commit }: any, payload: any) => {
      commit(SET_ORGANIZATION, { data: null, isLoading: true });

      const result: AxiosResponse = await Organization.registerOrganization(
        payload as RegisterOrganization
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ORGANIZATION, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_ORGANIZATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ORGANIZATION, { isLoading: false });
        return false;
      }
    },
    [SIGNUP_ORGANIZATION]: async ({ commit }: any, payload: any) => {
      commit(SET_ORGANIZATION, { data: null, isLoading: true });

      const result: AxiosResponse = await Organization.signupOrganization(
        payload as RegisterOrganization
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ACCOUNT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ORGANIZATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ORGANIZATION, { isLoading: false });
        return false;
      }
    },
    [GET_ORGANIZATIONS]: async ({ commit }: any, payload: any) => {
      commit(SET_ORGANIZATIONS, { data: null, isLoading: true });

      const result: AxiosResponse = await Organization.getOrganizations(
        payload as GetOrganization
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ORGANIZATIONS, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_ORGANIZATIONS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ORGANIZATIONS, { isLoading: false });
        return false;
      }
    },
    [GET_ORGANIZATION]: async ({ commit }: any, payload: any) => {
      commit(SET_ORGANIZATION, { data: null, isLoading: true });

      const result: AxiosResponse = await Organization.getOrganizations(
        payload as GetOrganization
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ORGANIZATION, {
            data: result.data.data[0],
            isLoading: false,
          });
          return true;
        }
        commit(SET_ORGANIZATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ORGANIZATION, { isLoading: false });
        return false;
      }
    },
    [EDIT_ORGANIZATION]: async (
      { commit }: any,
      payload: FormData
    ) => {
      commit(SET_ORGANIZATION, { data: null, isLoading: true });

      const result: AxiosResponse =
        await Organization.editOrganization(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ORGANIZATION, {
            data: result.data.data,
            isLoading: false,
          });
          // Update the organization in the account state using proper mutation
          commit(SET_ACCOUNT_ORGANIZATION, result.data.data, { root: true });

          return true;
        }
        commit(SET_ORGANIZATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ORGANIZATION, { isLoading: false });
        return false;
      }
    },
    [DELETE_ORGANIZATION]: async ({ commit }: any, payload: string) => {
      commit(SET_ORGANIZATION, { data: null, isLoading: true });

      const result: AxiosResponse =
        await Organization.deleteOrganization(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ORGANIZATION, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_ORGANIZATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ORGANIZATION, { isLoading: false });
        return false;
      }
    },
    [CLEAR_ORGANIZATION_ISLOADING]: ({ commit }) => {
      commit(SET_ORGANIZATION, { isLoading: false });
      commit(SET_ORGANIZATIONS, { isLoading: false });
    },
  },
};

export default organization;
